import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

interface Props {
  serviceFeePercent: number;
  isResale?: boolean;
}

/**
 * An info icon that'll show a tooltip on hover. The tooltip contains the passed {@link Props.serviceFeePercent|serviceFeePercent}.
 */
const InfoPostfix: React.FC<Props> = ({
  serviceFeePercent,
  isResale = false,
}) => {
  const { t } = useTranslation();
  const tooltipKey = isResale
    ? 'estimatedEarnings.ready.tooltip.resale'
    : 'estimatedEarnings.ready.tooltip';

  return (
    <SimpleTooltip
      text={t(tooltipKey, { serviceFeePercent })}
    >
      <InfoIcon
        aria-label={t(tooltipKey, { serviceFeePercent })}
        size={IconSize.SMALLER}
        disableDefaultColors
      />
    </SimpleTooltip>
  );
};

InfoPostfix.displayName = 'InfoPostfix';

export default InfoPostfix;
